import $ from "jquery";

export const StaffNumbers = () => {
  const uniqueStaffIds = new Set();

  const toggleBadge = (elem, count) => {
    const badge = elem.find(".badge").first();
    const parent = badge.parents("span").first();

    if (count > 0) {
      parent.css({ paddingRight: "20px" });
      badge.text(count).css({ display: "block" });
    } else {
      parent.css({ paddingRight: "0px" });
      badge.text("").css({ display: "none" });
    }
  };

  const specialDepts = $(".li-dept").filter(".is-exo-travel, .is-exo-group");

  $(".li-dept")
    .not(".is-exo-travel, .is-exo-group")
    .each(function () {
      const elem = $(this);
      const ids = [
        ...new Set(
          elem
            .find(".staff")
            .map((_, el) => el.id)
            .get()
            .filter(Boolean)
        ),
      ];

      ids.forEach((id) => uniqueStaffIds.add(id));
      toggleBadge(elem, ids.length);
    });

  const totalStaff = uniqueStaffIds.size;
  specialDepts.each(function () {
    toggleBadge($(this), totalStaff);
  });
};

export const GetUserRootId = (deptRootId, userDepts, childs) => {
  let userRootId = 0;
  const tmpChilds = { ...childs };
  const queues = [deptRootId];

  while (queues.length > 0) {
    const el = queues[0];
    if (el in userDepts) {
      userRootId = userDepts[el][0];
      break;
    }
    if (el in tmpChilds && tmpChilds[el].length > 0) {
      const firstElem = parseInt(tmpChilds[el][0]);
      queues.unshift(firstElem);
      tmpChilds[el] = tmpChilds[el].filter((item) => item !== firstElem);
    } else {
      queues.shift();
    }
  }
  return userRootId;
};

export const GetUserRoots = (data) => {
  let rootId = data.root_id;
  const childs = data.childs;
  const details = data.details;
  const userDepts = data.user_depts;
  const userDetails = data.user_details;

  const res = { dept_root: {}, user_root: [] };
  if (!rootId) return res;
  if (rootId === 1) rootId = 2;
  if (!(rootId in details)) return res;

  res.dept_root = details[rootId];
  const rootChilds = rootId in childs ? childs[rootId] : [];
  if (!rootChilds.length) return res;

  const userRoots = [];
  for (const child of rootChilds) {
    const userRootId = GetUserRootId(child, userDepts, childs);
    if (!userRootId) continue;

    if (
      userRootId in userDetails &&
      userDetails[userRootId].is_top_level === 1
    ) {
      userRoots.push(userRootId);
    }
  }
  res.user_root = userRoots;
  return res;
};
